export default {
  name: null,
  standard: null,
  status: 'inactive',
  slug: null,
  order: 1,
  static: {
    occupancy: {
      adults: null
    },
    extrabeds: 0,
    single_stay: false,
    small_child_in_bed: false,
    facilities: []
  },
  rate_plans: []
}